var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.4141 7.29163H14.5807C8.33073 7.29163 4.16406 10.4166 4.16406 17.7083V32.2916C4.16406 39.5833 8.33073 42.7083 14.5807 42.7083H35.4141C41.6641 42.7083 45.8307 39.5833 45.8307 32.2916V17.7083C45.8307 10.4166 41.6641 7.29163 35.4141 7.29163ZM36.3932 19.9791L29.8724 25.1875C28.4974 26.2916 26.7474 26.8333 24.9974 26.8333C23.2474 26.8333 21.4766 26.2916 20.1224 25.1875L13.6016 19.9791C12.9349 19.4375 12.8307 18.4375 13.3516 17.7708C13.8932 17.1041 14.8724 16.9791 15.5391 17.5208L22.0599 22.7291C23.6432 24 26.3307 24 27.9141 22.7291L34.4349 17.5208C35.1016 16.9791 36.1016 17.0833 36.6224 17.7708C37.1641 18.4375 37.0599 19.4375 36.3932 19.9791Z",
    fill: "#0082CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.32af368e597420e40dbc3cf88c7cd3ff.svg";
export { ForwardRef as ReactComponent };